import { useMemo } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useAppStore } from '@/store/appStore'
import { buildActiveFilterChips, buildPracticeFilterChips } from '@/utils/filterChips'
import type { GetContentBundleResponse } from '@/types/api'

/** Null `chipsByPractice` means no framework or context filter is active. Legend-hidden chips are left out. */
export function useFilterChips(bundle: GetContentBundleResponse | undefined) {
  const selectedFrameworkIds = useAppStore((s) => s.selectedFrameworkIds)
  const selectedContentTagIds = useAppStore((s) => s.selectedContentTagIds)
  const hiddenFilterChipKeys = useAppStore((s) => s.hiddenFilterChipKeys)
  return useMemo(
    () =>
      bundle
        ? buildPracticeFilterChips(bundle, selectedFrameworkIds, selectedContentTagIds, hiddenFilterChipKeys)
        : null,
    [bundle, selectedFrameworkIds, selectedContentTagIds, hiddenFilterChipKeys],
  )
}

export function useActiveFilterChips(bundle: GetContentBundleResponse | undefined) {
  const selectedFrameworkIds = useAppStore((s) => s.selectedFrameworkIds)
  const selectedContentTagIds = useAppStore((s) => s.selectedContentTagIds)
  return useMemo(
    () => (bundle ? buildActiveFilterChips(bundle, selectedFrameworkIds, selectedContentTagIds) : null),
    [bundle, selectedFrameworkIds, selectedContentTagIds],
  )
}

export function useFilterChipLabels() {
  const preference = useAppStore((s) => s.filterChipLabels)
  const prefersMoreContrast = useMediaQuery('(prefers-contrast: more)')
  return preference ?? prefersMoreContrast
}
